// Komponenten <eui-flikgrupp>:

import euiFlikgruppClasses from 'v-components/classes/euiFlikgruppClasses';


import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';

import euiModifieradSvg from 'v-components/euiModifieradSvg';
import euiMermeny from 'v-components/euiMermeny';

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-flikgrupp',

	// :to="portalTargetName"
	template: `
		<ul
			:id="uniktId"
			class="_eui-flikgrupp"
			:class="{
				'-inaktiverad':skaVaraInaktiverad,
				'-osynlig':skaVaraOsynlig,
			}"
			:disabled="skaVaraInaktiverad"
		>
			<!-- ##### Flik: #########################################-->

			<!--	:tabindex="(flik.arValbar && !flik.disabled ? 0 : -1)"-->
			<li v-for="(flik, flikIndex) in flikgruppConfig.flikar" :key="flikIndex"
				v-show="!flik.hidden"
				class="_eui-flikgrupp_flik"
				:class="{
					'-vald':flik.vald,
					'-har-ikon':flik.ikon,
					'-har-meny':flik.menyConfig,
					'-ghost':flik.arGhost,
				}"
			>
				<!-- @click.stop.prevent hindrar webbläsarens egna toggling, vilket förhindrar att den får en fokusring vid just klick (den ska få det vid tabbning): -->
				<a
					:flik-index="flik.index"
					:disabled="flik.disabled"
					:tabindex="(flik.disabled || flik.vald ? -1 : 0)"
					:title="!flik.disabled && flik.tooltip"
					class="ellipsis"
					@click.stop.prevent="onFlikVald(flik.index)"
					@keyup.enter.stop="onFlikVald(flik.index)"
					@keyup.space.stop="onFlikVald(flik.index)"
				>

					<!-- ####### Ev ikon: -->

					<span v-if="flik.ikon"
						class="_eui-flikgrupp_flik_ikoncontainer"
					>
						<!--	:vp-svg-markup="allaSvgikoner[flik.ikon]"-->
						<eui-modifierad-svg
							:vp-ikon="flik.ikon"
							style="
								height: 1.2em;
								width: 1.2em;
							"
						></eui-modifierad-svg>
					</span>


					<!-- ####### Texten: -->

					<span
						class="_eui-flikgrupp_flik_text"
						v-html="flik.text"
					></span>


					<!-- ####### Ev mermeny: -->

					<!--	style="width:40px; height:100%; display:inline-flex;"-->
					<eui-mermeny v-if="flik.menyConfig"
						:vp-meny-config.sync="flik.menyConfig"
						vp-burgare-ikon-av-storlek="1.5rem"
						class="_eui-flikgrupp_flik_meny"
						@menyalternativ-valt-i-mermeny="onMenyalternativValt"
					></eui-mermeny>


				</a>
			</li>
						
		</ul>
	`,

	components: {
		euiModifieradSvg,
		euiMermeny,
	},

	mixins: [ euiLifecycleStatusesMixin ],

	//directives: {
	//},

	props: {
		vpFlikgruppConfig: {
			type: [euiFlikgruppClasses.flikgruppConfig, Object],		// Object här också för att inte få type check-fel i tid och otid när man manipulerar dennes värde i anropande kod :(
			required: true,
		},

		// Propen används med .sync i parent component:
		vpValdFlikIndex: {					// null/undefined = vald flik sätts inte utifrån detta index.
			//type: [null, Number],
			default: undefined,
		},

		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			uniktId: 'eui-flikgrupp-unikt-' + (++uniktIdCounter),

			flikgruppConfig: this.vpFlikgruppConfig,
		};
	},

	computed: {
		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
		},

		skaVaraInaktiverad() {
			return (this.vpInaktiverad);				// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
		},
	},

	watch: {
		vpValdFlikIndex: {
			handler(nyttVarde, tidigareVarde) {
				//console.log(`Cat changed: ${nyttVarde}`);

				this.flikgruppConfig.valjFlikMedIndex(nyttVarde);
			},
			immediate: true,		// OBS! Exekveras även initialt!
		},

		vpFlikgruppConfig(nyttVarde, tidigareVarde)
		{
			this.flikgruppConfig = nyttVarde;
		},

		flikgruppConfig(nyttVarde, tidigareVarde)
		{
			// Propen används med .sync i parent component:
			this.$emit('update:vpFlikgruppConfig', nyttVarde);
		},
	},

	methods: {

		onFlikVald(flikIndex) {
			//console.log(`Flik med index ${flikIndex} vald`);

			// Fick inte .stop.prevent att funka så som för eui-switch :(
			// Sänker mig till denna *fuling*:
			// (Mer om fokus vid klick på https://www.sitepoint.com/when-do-elements-take-the-focus/.)
			document.activeElement.blur();

			const valdaFliken = this.flikgruppConfig.flikar[flikIndex];

			if (!valdaFliken.vald)
			{
				// Om fliken inte redan är den valda:
				//for (const flik of this.flikgruppConfig.flikar)
				//{
				//	flik.vald = false;
				//}

				if (!valdaFliken.arGhost)
				{
					// Bara om det *inte* är en virtuell ghost-flik (för då ska bara flik-vald-eventet nedan skickas):

					// Propen används med .sync i parent component:
					this.$emit('update:vpValdFlikIndex', flikIndex);

					// Själva det visuella flikbytet (och uppdatering av den bakomliggande datamodellen) sker reaktivt i watch ovan!
				}

				this.$emit('flik-vald',
					// Payload:
					{ eventId: valdaFliken.eventId, eventData: valdaFliken.eventData }
				);
			}
		},

		onMenyalternativValt({ eventId, eventData }) {

			this.$emit('menyalternativ-valt-i-flik',
				// Payload:
				{ eventId: eventId, eventData: eventData }
			);
		},
	},






	//== Lifecycle hooks  ================================================================================================================

	//beforeCreate() {
	//	// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.
	//	//console.log('beforeCreate: flikgrupp', this.uniktId);

	//	// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
	//	// Exempel: this.$_undertryckNastaAndradEvent = false;
	//},

	//created() 
	//{
	//	// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

	//	// https://medium.com/@brockreece/vue-parent-and-child-lifecycle-hooks-5d6236bd561f
	//	// A component becomes reactive just before the Created hook is fired, this means it will start to track changes of it’s props before it’s parent’s Mounted hook has fired. This is worth remembering if you have logic setting the value of a prop in the parent’s Mounted hooks.
	//	// The example below shows the difference between preparing your prop data in both the Created and Mounted hooks of the parent component. As you can see, the prop that was set in the Mounted hook reacts twice on the child component.
	//	// ...
	//	// Imagine if your child component made an Ajax request every time this prop changes, this would cause twice as much network activity and this could easily respond out of order.
	//	// As a quick rule of thumb, I suggest only using the Mounted hook if your component needs to interact with the DOM, anything else should probably be taken care of in the Created hook.

	//	//console.log('created: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},

	//beforeMount()
	//{
	//	// Called right before the mounting begins: the render function is about to be called for the first time.
	//	// This hook is not called during server-side rendering.
	//	// Detta är hooken efter att Vues kompilering är klar. v-cloak är fortfarande kvar, men plockas bort strax efter denna körts.
	//	// Här är det inte lämpligt att förändra DOM, för den ersätts vid den stundande renderingen och då tappas ändringarna (är jag ganska säker på).
	//	console.log('beforeMount: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},

	//mounted() {
	//	// Note that mounted does not guarantee that all child components have also been mounted.
	//	//-----------------------------------------------------------------------------------------------------------------------
	//	// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
	//	//
	//	// 1. Mixins mounted hook.
	//	// 2. Appens/komponentens mounted hook.
	//	//
	//	// 3. Mixins mounted hook + nextTick (DOM not updated yet).
	//	// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
	//	//
	//	// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
	//	// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
	//	//
	//	// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
	//	//
	//	// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
	//	// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
	//	// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
	//	//-----------------------------------------------------------------------------------------------------------------------
	//	//console.log('mounted: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);

	//	//## 2. Appens/komponentens mounted hook:  #################################		
	//	//console.log('2. Appens/komponentens mounted hook');

	//	this.$nextTick(function () {
	//		// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
	//		// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

	//		//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################		
	//		//console.log('4. Appens/komponentens mounted hook + nextTick');

	//		//console.log('mounted+NextTick: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//	});
	//},

	//beforeUpdate()
	//{
	//	// Called when data changes, before the DOM is patched. This is a good place to access the existing DOM before an update, e.g. to remove manually added event listeners.
	//	// This hook is not called during server-side rendering, because only the initial render is performed server-side.
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	//	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//	console.log('beforeUpdate: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},

	//updated()
	//{
	//	// Called after a data change causes the virtual DOM to be re-rendered and patched.
	//	// The component’s DOM will have been updated when this hook is called, so you can perform DOM-dependent operations here. However, in most cases you should avoid changing state inside the hook. To react to state changes, it’s usually better to use a computed property or watcher instead.
	//	// This hook is not called during server-side rendering.
	//	// Note that updated does not guarantee that all child components have also been re-rendered.
	//	// Denna hook körs även efter mounted!
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	//	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//	console.log('updated: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},

	//activated()
	//{
	//	// Called when a *kept-alive* component is activated.
	//	// This hook is not called during server-side rendering.
	//},

	//deactivated()
	//{
	//	// Called when a *kept-alive* component is deactivated.
	//	// This hook is not called during server-side rendering.
	//},

	//beforeDestroy()
	//{
	//	// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
	//	// This hook is not called during server-side rendering.
	//	//console.log('beforeDestroy: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},

	//destroyed()
	//{
	//	// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
	//	// This hook is not called during server-side rendering.
	//	//console.log('destroyed: flikgrupp', this.vpVisaMenyn, this.visaMenyn, this.uniktId);
	//},
};
